import Button from './Button';
import './ui.css';

const CtaBanner = ({
  title = 'Contact Bethel Innovations',
  body = 'Tell us about your project, compliance requirements, or operational challenges. Our team will respond within one business day.',
  primary = { label: 'Contact Us', to: '/contact-us' },
  secondary,
}) => (
  <section className="cta-banner on-navy" aria-labelledby="cta-banner-title">
    <div className="container cta-banner__inner">
      <div className="cta-banner__text">
        <h2 id="cta-banner-title" className="cta-banner__title">
          {title}
        </h2>
        <p className="cta-banner__body">{body}</p>
      </div>
      <div className="cta-banner__actions">
        <Button to={primary.to} variant="invert" size="lg">
          {primary.label}
        </Button>
        {secondary && (
          <Button to={secondary.to} variant="ghost-invert" size="lg">
            {secondary.label}
          </Button>
        )}
      </div>
    </div>
  </section>
);

export default CtaBanner;
